import React from 'react'
import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import ImageTextPanel from '../../components/inner/technologies/ImageTextPanel'
import ImageTitleTextCard from '../../components/inner/technologies/ImageTitleTextCard'

import AutomotiveImage02 from '../../assets/technologies/automotiveImage02.png'
import SecurityImage01 from '../../assets/technologies/securityImage01.png'
import SecurityImage02 from '../../assets/technologies/securityImage02.png'
import SecurityImage03 from '../../assets/technologies/securityImage03.png'
import styled from 'styled-components'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const Security = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.security || siteCopy.en.pages.technologies.security;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <HeaderContainer>
      <HeaderTitle>{copy.title}</HeaderTitle>

      <ImageTitleTextCardContainer>
        {copy.cards.map((card, index) => (
          <ImageTitleTextCard
            key={index}
            Image={index === 0 ? SecurityImage01 : index === 1 ? SecurityImage02 : SecurityImage03}
            Title={card.title}
            Text={<>{renderLines(card.text)}</>}
          />
        ))}
      </ImageTitleTextCardContainer>
      
      <SubHeading>{copy.solutionTitle}</SubHeading>

      <ImageTextPanel 
          Image={AutomotiveImage02}
          Title={copy.solution.title}
          Link={copy.solution.link}
          Text={<>{renderLines(copy.solution.text)}</>}/>

    </HeaderContainer>
  )
}

const ImageTitleTextCardContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  padding-top: 40px;
  padding-bottom: 40px;

    /* 0px 이상 800px 미만 */
    @media (min-width: 1px) and (max-width: 1400px) {
    flex-direction: column;
  }

`

export default Security
